"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResolvedValueElementMetadataKind = void 0;
var ResolvedValueElementMetadataKind;
(function (ResolvedValueElementMetadataKind) {
    ResolvedValueElementMetadataKind[ResolvedValueElementMetadataKind["multipleInjection"] = 0] = "multipleInjection";
    ResolvedValueElementMetadataKind[ResolvedValueElementMetadataKind["singleInjection"] = 1] = "singleInjection";
})(ResolvedValueElementMetadataKind || (exports.ResolvedValueElementMetadataKind = ResolvedValueElementMetadataKind = {}));
//# sourceMappingURL=ResolvedValueElementMetadataKind.js.map